import React from "react";
import { Tooltip, TooltipProps } from "@mui/material";

type BaseTooltipVariant = "default" | "error";

const tooltipPalette: Record<
    BaseTooltipVariant,
    {
        backgroundColor: string;
        textColor: string;
        border?: string;
    }
> = {
    default: {
        backgroundColor: "#C8E98E",
        textColor: "#3C3769",
    },
    error: {
        backgroundColor: "#FDECEC",
        textColor: "#3C3769",
        border: "1px solid #E25C5C",
    },
};

export const BaseTooltip = ({
    children,
    placement,
    active = true,
    variant = "default",
    ...rest
}: TooltipProps & { active?: boolean; variant?: BaseTooltipVariant }) => {
    if (!active) return children;

    const palette = tooltipPalette[variant];

    return (
        <Tooltip
            placement={placement ?? "right"}
            arrow
            componentsProps={{
                tooltip: {
                    sx: {
                        bgcolor: palette.backgroundColor,
                        border: palette.border,
                        "& .MuiTooltip-arrow": {
                            color: palette.backgroundColor,
                        },
                        color: palette.textColor,
                        fontSize: "14px",
                        fontWeight: "light",
                        padding: "8px",
                    },
                },
            }}
            {...rest}
        >
            <span className="cursor-pointer">{children}</span>
        </Tooltip>
    );
};

export default BaseTooltip;
